import React, { Component } from 'react';
//import { inject, observer } from 'mobx-react';
//import { toJS } from 'mobx';
import { Button/* , Icon, Form, Modal, Input */ } from 'antd';
import intl from 'react-intl-universal';
import {store} from 'Store/store.index';
import { 
  PROM4_CLICKED   ,
} from 'Components/viewer/ui/constants/user.more.constants';
import './BottomAd.scss';
import {windowActionFn} from 'Utils/utils'

export default class BottomAd extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  componentDidMount() {}
  componentWillUnmount() {}
  goToSubscribe = () => {
    let url = '';
    const winEnv = windowActionFn(window, 'open', ['about:blank']);

    const {isWindowsOS, isMacOS} = store.appStore;
    /**
      For users on Windows:  
      https://www.foxitsoftware.com/downloads/#Foxit-PhantomPDF-Business/?page=ga&from=online-view-window 
      For user on MacOS: 
      https://www.foxitsoftware.com/downloads/#Foxit-PhantomPDF-Mac/?page=ga&from=online-view-window 
    */

    if (isMacOS) {
      url = "https://globe-map.foxitservice.com/go.php?title=download-phantom-mac&product=Foxit%20PhantomPDF%20Online&&edition=&version=&utm_source=online-view-window&language=";
    } else if (isWindowsOS) {
      url = "https://globe-map.foxitservice.com/go.php?title=download-phantom&product=Foxit%20PhantomPDF%20Online&&edition=&version=&utm_source=online-view-window&language=";
    }
    url += store.appStore.lng.full;

    winEnv.document.location.href = url;

    store.userStore.doSendGAEvent({ eventKey: PROM4_CLICKED, label: 'getting_started' });
  };

  render() {
    return (
      <div className="bottom-subscribe-wrapper">
        <i className="close-btn" onClick={this.props.onClose}>
          ×
        </i>
        <span>
          {intl.get('BottomAd.MoreFeature')}
          <Button className="online-solid-btn subscribe-btn" onClick={this.goToSubscribe}>
          {intl.get('BottomAd.FreeTrial')}
          </Button>
        </span>
      </div>
    );
  }
}
